import React from "react";
import PropTypes from "prop-types";
import ProgressButton from "react-progress-button";

const SendEstimateButton = ({
	buttonState,
	handleSave,
	dataTestId
}) => {
	const { lang } = global;

	return (
		<ProgressButton
			id="send-job-estimate"
			data-test-id={dataTestId}
			className="btn btn-primary form-progress-button"
			state={buttonState}
			onClick={handleSave}
		>
			{lang.t("Send Estimate")}
		</ProgressButton>
	);
};

SendEstimateButton.propTypes = {
	buttonState: PropTypes.string.isRequired,
	handleSave: PropTypes.func.isRequired,
	dataTestId: PropTypes.string
};

SendEstimateButton.defaultProps = {
	dataTestId: undefined
};

export default SendEstimateButton;
